import { Form } from 'antd';

import { StepWrapper } from '../../../styles';
import { TranslatedTitle, TranslatedText } from '../components';

import { MasterDegreeRadio } from '@/components/Onboarding/MasterDegreeRadio';
import { Box } from '@/components/Utils';
import { RULES } from '@/constants';

export const MasterTeacher = () => {
  return (
    <StepWrapper>
      <div>
        <TranslatedTitle i18nKey="YOU_HAVE_MASTER_DEGREE" />
        <TranslatedText i18nKey="YOU_HAVE_MASTER_DEGREE_DESCRIPTION" />
      </div>
      <Box flexDirection="column" gap={12}>
        <Form.Item rules={[RULES.REQUIRED]} name={['userInfo', 'oposUserInfo', 'hasMasterDegree']}>
          <MasterDegreeRadio />
        </Form.Item>
      </Box>
    </StepWrapper>
  );
};
